
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HistoryItemContext, KIToolsUser, User } from '@shared/index';
import { KeyValEntry } from '@shared/KeyValStore';
import { ExcelExportComponent } from '@reflact/ngx-xlsx';
import { XLSXExportConfig } from 'src/app/shared/types/xlsx.types';
import { SocketAdminService } from '@shared-angular/services/socketadmin.service';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { RouteShareService } from '../../../../../../shared/services/route-share.service';

@Component({
  imports: [FormsModule, ExcelExportComponent, CardModule, InputTextModule, TableModule],
  templateUrl: './user-values-tab.component.html',
  styleUrl: './user-values-tab.component.scss'
})
export class UserValuesTabComponent {

  public keyvals: KeyValEntry<string>[] = [];
  public filteredKeyVals: KeyValEntry<string>[] = [];
  public users: User<string, string>[] = [];
  public guests: KIToolsUser[] = [];
  public filterString: string = "";
  public readonly exportConfig: XLSXExportConfig[] = [
    { fieldName: "username" },
    { fieldName: "key" },
    { fieldName: "value" },
    { fieldName: "type" }
  ];

  constructor(private aRoute: ActivatedRoute, private socketService: SocketAdminService, public rss: RouteShareService) {
    this.aRoute.data.subscribe((res: { data?: { users: User<string, string>[], guests: KIToolsUser[], keyvals: KeyValEntry<string>[] } }) => {
      if (res.data) {
        this.keyvals = res.data.keyvals;
        this.filterKeyvals();
        this.users = res.data.users;
        this.guests = res.data.guests;
      }
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.socketService.onkeyValChange.subscribe((data: KeyValEntry<any> & { context: { guestId?: string } }) => {
      data.value = (data as KeyValEntry<string>).value.toString();
      if (data.context.botid != this.rss.botConfig._id) {
        return;
      }
      const index = this.keyvals.findIndex(kv => kv._id == data._id);
      if (index > -1) {
        this.keyvals[index] = (data as KeyValEntry<string>);
      } else {
        this.keyvals.push((data as KeyValEntry<string>));
      }
      this.filterKeyvals();
    });

    this.socketService.onkeyValDelete.subscribe((data) => {
      this.keyvals = this.keyvals.filter(kv => {
        if (data.keepPersistant && kv.key.startsWith("!")) {
          return true;
        }
        return kv.context.botid != data.context.botid &&
          kv.context.user != data.context.user;
      });
      this.filterKeyvals();
    });

    this.socketService.onkeyValClean.subscribe(() => {
      this.keyvals = [];
      this.filterKeyvals();
    });
  }

  public getUserByContext(context: HistoryItemContext & { guestId?: string }) {

    if (context.guestId) {
      return context.guestId;
    }
    const username = this.users.find(u => u._id == context.user)?.name;
    if (username) return username;
    const guestname = this.guests.find(g => g._id == context.user)?.guestId;
    if (guestname) return guestname;
    return $localize`:@@user-not-found:Nutzer nicht gefunden` + ` (${context.user})`;
  }

  public filterKeyvals() {
    const searchStrings = this.filterString.split(" ").map(s => s.toLowerCase().trim()).filter(s => s != "");
    this.filteredKeyVals = this.keyvals.filter(k => {
      return searchStrings.every(s => {
        if (this.getUserByContext(k.context).toLowerCase().includes(s)) return true;
        if (k.key.toLowerCase().includes(s)) return true;
        if (k.type.toLowerCase().includes(s)) return true;
        if (k.value.toLowerCase().includes(s)) return true;
        return false;
      });
    });
  }

  public get exportData() {
    return this.filteredKeyVals.map(k => {
      return {
        username: this.getUserByContext(k.context),
        key: k.key,
        value: k.value,
        type: k.type
      };
    });
  }
}
